module.exports = __webpack_public_path__ + "img/alarm.931082a4.png";